import memoizeOne from 'memoize-one';
import { fetchJson } from '@atlassian/jira-fetch';
import type { UserGroups, UserGroup } from '../model/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toItem = (group: UserGroup): any => ({
	content: group.name,
	value: group.name,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformSuggestions = (suggestionsFromServer: UserGroups | null): any[] => {
	if (!suggestionsFromServer || !suggestionsFromServer.groups) {
		return [{ items: [] }];
	}

	return [{ items: suggestionsFromServer.groups.map(toItem) }];
};

export const fetchSuggestionsFactory = memoizeOne(
	() => (query: string) =>
		fetchJson(`/rest/api/2/groups/picker?query=${encodeURIComponent(query)}`).then((response) =>
			transformSuggestions(response),
		),
);
